module.exports = __webpack_public_path__ + "static/media/52753354_2452981801443663_7534134633101787136_o.021e5dec.jpg";